import { Flex } from "@chakra-ui/react";
import { BreadCrumbs } from "../BreadCrumbs";

export function Navbar() {
  return (
    <Flex borderBottom="1px solid #E6E9F0" bgColor="gray.10" h="100%">
      <Flex w="100%" h="100%" align="center" justify="space-between" p="0 1rem">
        {<BreadCrumbs />}
      </Flex>
    </Flex>
  );
}
